import type { FC, ReactNode } from "react";

interface DashboardCardProps {
  children: ReactNode;
  title: string;
}
export const DashboardCard: FC<DashboardCardProps> = (props) => {
  return (
    <div className={"text-sm bg-white border border-slate-200 rounded-lg px-3 py-3"}>
      <div className={"font-medium mb-3"}>{props.title}</div>
      <div>{props.children}</div>
    </div>
  );
};
